export default __webpack_public_path__ + "static/media/DissectIt_Step4.2f595f19.png";